const config = {
  BACKEND_HOST:
    process.env.REACT_APP_BACKEND_HOST ||
    process.env.BACKEND_HOST ||
    'localhost',
}

export default config
